import * as React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps } from '@material-ui/core';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tooltip: {
      backgroundColor: theme.colors.bgDarker,
      padding: theme.spacing(1),
    },
    arrow: {
      color: theme.colors.fgDefault,
    },
  })
);

export type TooltipProps = MuiTooltipProps;

/**
 * Tooltips display informative text when users hover over, focus on, or tap an element.
 *
 * ```js
 * import { Tooltip } from 'ui';
 * ```
 */
const Tooltip: React.FunctionComponent<TooltipProps> = ({ arrow, children, ...rest }) => {
  const classes = useStyles();
  return (
    <MuiTooltip classes={{ tooltip: classes.tooltip, arrow: classes.arrow }} arrow {...rest}>
      {children}
    </MuiTooltip>
  );
};

export default Tooltip;
